(function () {
  function initSection(section) {
    if (!section || section.dataset.supportSectionInit === '1') return;
    section.dataset.supportSectionInit = '1';

    const filterButtons = section.querySelectorAll('[data-filter]');
    const categorySections = section.querySelectorAll('[data-category]');

    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const filter = btn.dataset.filter;
        filterButtons.forEach(function (b) {
          const active = b === btn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        categorySections.forEach(function (cat) {
          const matches = filter === 'all' || cat.dataset.category === filter;
          if (matches) cat.removeAttribute('hidden');
          else cat.setAttribute('hidden', '');
        });
      });
    });

    const modal = section.querySelector('[data-pdf-modal]');
    if (!modal) return;
    const modalFrame = modal.querySelector('[data-modal-frame]');
    const modalImageWrap = modal.querySelector('[data-modal-image-wrap]');
    const modalImage = modal.querySelector('[data-modal-image]');
    const modalTitle = modal.querySelector('[data-modal-title]');
    const modalDownload = modal.querySelector('[data-modal-download]');
    const closeButtons = modal.querySelectorAll('[data-modal-close]');

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    function closeModal() {
      if (typeof modal.close === 'function' && modal.open) {
        try { modal.close(); } catch (_) { /* noop */ }
      }
      modal.removeAttribute('open');
      if (modalFrame) {
        modalFrame.src = 'about:blank';
        modalFrame.setAttribute('hidden', '');
      }
      if (modalImageWrap) modalImageWrap.setAttribute('hidden', '');
      if (modalImage) modalImage.removeAttribute('src');
    }

    closeButtons.forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    modal.addEventListener('cancel', function (e) {
      e.preventDefault();
      closeModal();
    });

    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });

    section.querySelectorAll('[data-preview-url]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const url = btn.dataset.previewUrl;
        const kind = btn.dataset.previewKind || 'pdf';
        const title = btn.dataset.previewTitle || 'Document preview';
        if (!url) return;

        if (kind === 'pdf' && isIOS) {
          window.open(url, '_blank', 'noopener');
          return;
        }

        if (modalTitle) modalTitle.textContent = title;
        if (modalDownload) modalDownload.href = url;

        if (kind === 'image') {
          if (modalFrame) {
            modalFrame.src = 'about:blank';
            modalFrame.setAttribute('hidden', '');
          }
          if (modalImage) {
            modalImage.src = url;
            modalImage.alt = title;
          }
          if (modalImageWrap) modalImageWrap.removeAttribute('hidden');
        } else {
          if (modalImageWrap) modalImageWrap.setAttribute('hidden', '');
          if (modalImage) modalImage.removeAttribute('src');
          if (modalFrame) {
            const sep = url.indexOf('#') === -1 ? '#' : '&';
            modalFrame.src = url + sep + 'view=FitH&toolbar=0';
            modalFrame.removeAttribute('hidden');
          }
        }

        if (typeof modal.showModal === 'function') {
          try { modal.showModal(); } catch (_) { modal.setAttribute('open', ''); }
        } else {
          modal.setAttribute('open', '');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-support-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const target = e.target.querySelector
      ? e.target.querySelector('[data-support-section]')
      : null;
    if (target) initSection(target);
  });
})();
